import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function expandingVideo() {    
    const section = $qs('[data-name="expanding-video"]');
    if(!section) return;
    const video = $qs('[data-target="expanding-video"]', section);

    gsap.to(video, {
        scrollTrigger: {
            trigger: section,
            scrub: true,
            start: '10% bottom',
            end: 'bottom bottom',
            // markers: true
        },
        scale: 1,
        ease: 'none'
    });
}

export default expandingVideo;